import { ITableColumn } from '@components/common/UTable/UTable';

export const columns = [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Дата наряда',
    dataIndex: 'taskDate',
    type: 'date',
  },
  {
    title: 'Хозяйство',
    dataIndex: 'organizationName',
  },
] as ITableColumn[];
